export default __webpack_public_path__ + "static/media/login2.7417d944.svg";